import "../styles/partners.css";

import partner1 from "../assets/img/partner/Greenwich.png";
import partner2 from "../assets/img/partner/cao-dang-viet-my.png";
import partner3 from "../assets/img/partner/hi-cafe.png";
import partner4 from "../assets/img/partner/logo-atv.png";
import partner5 from "../assets/img/partner/logo-bvdkct.png";
import partner6 from "../assets/img/partner/logo-cao-dang-tay-do.png";
import partner7 from "../assets/img/partner/logo-dhct.png";
import partner8 from "../assets/img/partner/logo-dktu-ct.png";
import partner9 from "../assets/img/partner/logo-duynguyen.png";
import partner10 from "../assets/img/partner/logo-evn.png";
import partner11 from "../assets/img/partner/logo-ghp.png";
import partner12 from "../assets/img/partner/logo-hgv.png";
import partner13 from "../assets/img/partner/logo-hong-bang.png";
import partner14 from "../assets/img/partner/logo-kahami.png";
import partner15 from "../assets/img/partner/logo-melody.png";
import partner16 from "../assets/img/partner/logo-nam-cantho.png";
import partner17 from "../assets/img/partner/logo-optimum.png";
import partner18 from "../assets/img/partner/logo-redielac.png";
import partner19 from "../assets/img/partner/logo-sala-realty.png";
import partner20 from "../assets/img/partner/logo-taydo.png";
import partner21 from "../assets/img/partner/logo-thtpct.png";
import partner22 from "../assets/img/partner/logo-thtv.png";
import partner23 from "../assets/img/partner/logo-vtv.png";
import partner24 from "../assets/img/partner/vinamilk.png";

const partners = [
  { id: 1, src: partner1, alt: "Greenwich" },
  { id: 2, src: partner2, alt: "cao-dang-viet-my" },
  { id: 3, src: partner3, alt: "hi-cafe" },
  { id: 4, src: partner4, alt: "logo-atv" },
  { id: 5, src: partner5, alt: "logo-bvdkct" },
  { id: 6, src: partner6, alt: "logo-cao-dang-tay-do" },
  { id: 7, src: partner7, alt: "logo-dhct" },
  { id: 8, src: partner8, alt: "logo-dktu-ct" },
  { id: 9, src: partner9, alt: "logo-duynguyen" },
  { id: 10, src: partner10, alt: "logo-evn" },
  { id: 11, src: partner11, alt: "logo-ghp" },
  { id: 12, src: partner12, alt: "logo-hgv" },
  { id: 13, src: partner13, alt: "logo-hong-bang" },
  { id: 14, src: partner14, alt: "logo-kahami" },
  { id: 15, src: partner15, alt: "logo-melody" },
  { id: 16, src: partner16, alt: "logo-nam-cantho" },
  { id: 17, src: partner17, alt: "logo-optimum" },
  { id: 18, src: partner18, alt: "logo-redielac" },
  { id: 19, src: partner19, alt: "logo-sala-realty" },
  { id: 20, src: partner20, alt: "logo-taydo" },
  { id: 21, src: partner21, alt: "logo-thtpct" },
  { id: 22, src: partner22, alt: "logo-thtv" },
  { id: 23, src: partner23, alt: "logo-vtv" },
  { id: 24, src: partner24, alt: "vinamilk" },
];

const Partners = () => {
  return (
    <div className="partners-bg">
      <div className="partners">
        <div className="partners__wrapper">
          <h2 className="partners__title">
            Các đối tác khách hàng
            <span className="line"></span>
          </h2>
        </div>

        <div className="partners__list">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="partners__item"
            >
              <div className="partner-content">
                <img
                  src={partner.src}
                  alt={partner.alt}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners;
